const trialConfig = {
  EAME: {
    crops: ['sunflower', 'corn', 'silage corn', 'barley', 'grain corn'],
    location: '111,000',
  },
  LATAM: {
    crops: ['summer corn', 'winter corn', 'soybean'],
    location: '111,000',
  },
  SA: {
    crops: ['wheat'],
    location: '111,000',
  },
  brasil: {
    crops: {
      'safra corn': '9000',
      'safrina corn': '9000',
      'safrinha corn': '9000',
      'summer corn': '9000',
      'winter corn': '9000',
      soybean: '6000',
      soybeans: '6000',
    },
  },
};

const trialLocationData = Object.entries(trialConfig).flatMap(([region, config]) => {
  if (Array.isArray(config.crops)) {
    return config.crops.map((cropName) => ({
      region,
      cropName,
      trialLocation: 'location' in config ? config.location : '',
    }));
  } else {
    return Object.entries(config.crops).map(([cropName, location]) => ({
      region,
      cropName,
      trialLocation: location,
    }));
  }
});

export const getTrialLocation = (cropName: string, region: string): string => {
  const normalizedCropName = cropName.toLowerCase();
  const normalizedRegion = region.toLowerCase();
  return (
    trialLocationData.find(
      (data) =>
        data.cropName.toLowerCase() === normalizedCropName &&
        data.region.toLowerCase() === normalizedRegion
    )?.trialLocation ?? ''
  );
};
